import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';

// ── Images ────────────────────────────────────────────────────────────────────
import heroImg    from '../../images/portfolio/sg-01.jpg';
import detailImg1 from '../../images/services/service_details_image_1.webp';
import detailImg2 from '../../images/services/service_details_image_2.webp';

import g1  from '../../images/portfolio/sg-01.jpg';
import g2  from '../../images/portfolio/sg-02.jpg';
import g3  from '../../images/portfolio/sg-04.jpg';
import g4  from '../../images/portfolio/sg-03.jpg';
import g5  from '../../images/portfolio/sg-05.jpg';
import g6  from '../../images/portfolio/sg-06.jpg';
import g7  from '../../images/portfolio/sg-07.jpg';
import g8  from '../../images/portfolio/sg-08.jpg';
import g9  from '../../images/portfolio/sg-09.jpg';
import g10 from '../../images/portfolio/sg-10.jpg';
import g11 from '../../images/portfolio/sg-11.jpg';
import g12 from '../../images/portfolio/sg-12.jpg';

import iconCamera  from '../../images/icons/icon_photo_camera_2.svg';
import iconProcess from '../../images/icons/icon_process_2.svg';
import iconContent from '../../images/icons/icon_content_creation_2.svg';
import iconMeeting from '../../images/icons/icon_meeting_2.svg';
import iconCheck   from '../../images/icons/icon_check_3.svg';
import iconMap     from '../../images/icons/icon_map_mark_2.svg';
import iconCall    from '../../images/icons/icon_calling_2.svg';
import iconMail    from '../../images/icons/icon_mail_3.svg';
import iconCal     from '../../images/icons/icon_calendar_2.svg';

// ── Styles ────────────────────────────────────────────────────────────────────
const studioStyles = `

  /* ── Studio Intro ── */
  .studio-intro-section { padding: 100px 0 80px; background: #fff; }
  .studio-hero-img {
    width: 100%; border-radius: 6px; object-fit: cover;
    max-height: 520px; box-shadow: 0 24px 60px rgba(0,0,0,0.10);
  }
  .studio-badge {
    display: inline-block; padding: 5px 16px; background: #f4f4f4;
    border-left: 3px solid #111; font-size: 11px; letter-spacing: 3px;
    text-transform: uppercase; font-weight: 600; color: #111; margin-bottom: 18px;
  }
  .studio-heading {
    font-size: clamp(28px, 4vw, 46px); font-weight: 700;
    line-height: 1.15; color: #111; margin-bottom: 20px;
  }
  .studio-heading mark {
    background: none; color: #111;
    border-bottom: 3px solid #111; padding-bottom: 2px;
  }
  .studio-lead { font-size: 16px; color: #555; line-height: 1.8; margin-bottom: 24px; }

  /* Stats Bar */
  .studio-stats-bar {
    display: flex; gap: 0; border: 1px solid #e8e8e8;
    border-radius: 6px; overflow: hidden; margin-bottom: 40px;
  }
  .studio-stat-item {
    flex: 1; padding: 24px 20px; text-align: center;
    border-right: 1px solid #e8e8e8; background: #fafafa; transition: background 0.2s;
  }
  .studio-stat-item:last-child { border-right: none; }
  .studio-stat-item:hover { background: #f0f0f0; }
  .studio-stat-num { font-size: 32px; font-weight: 800; color: #111; line-height: 1; margin-bottom: 4px; }
  .studio-stat-lbl { font-size: 11px; letter-spacing: 1.5px; text-transform: uppercase; color: #888; }
  @media (max-width: 576px) {
    .studio-stats-bar { flex-wrap: wrap; }
    .studio-stat-item { flex: 1 1 50%; border-right: 1px solid #e8e8e8; }
  }

  /* Features */
  .studio-features-section { padding: 80px 0; background: #f8f8f8; }
  .studio-features-grid {
    display: grid; grid-template-columns: repeat(4,1fr); gap: 20px; margin-top: 50px;
  }
  @media (max-width: 992px) { .studio-features-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 576px) { .studio-features-grid { grid-template-columns: 1fr; } }
  .studio-feature-card {
    background: #fff; border-radius: 6px; padding: 36px 28px;
    border: 1px solid #efefef; transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
    position: relative; overflow: hidden;
  }
  .studio-feature-card::after {
    content: ''; position: absolute; bottom: 0; left: 0; right: 0;
    height: 3px; background: #111; transform: scaleX(0);
    transform-origin: left; transition: transform 0.3s;
  }
  .studio-feature-card:hover { transform: translateY(-6px); box-shadow: 0 20px 50px rgba(0,0,0,0.10); }
  .studio-feature-card:hover::after { transform: scaleX(1); }
  .studio-feature-icon { width: 52px; height: 52px; margin-bottom: 20px; }
  .studio-feature-title { font-size: 18px; font-weight: 700; color: #111; margin-bottom: 10px; }
  .studio-feature-desc { font-size: 14px; color: #777; line-height: 1.7; margin: 0; }

  /* Gallery */
  .studio-gallery-section { padding: 90px 0 70px; background: #fff; }
  .studio-section-eyebrow {
    font-size: 11px; letter-spacing: 3px; text-transform: uppercase;
    color: #888; font-weight: 600; margin-bottom: 10px;
  }
  .studio-section-title {
    font-size: clamp(26px, 3.5vw, 42px); font-weight: 700;
    color: #111; margin-bottom: 8px; line-height: 1.15;
  }
  .studio-section-sub { font-size: 15px; color: #777; margin-bottom: 40px; }

  .studio-filter-tabs { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 36px; }
  .studio-filter-btn {
    padding: 8px 22px; border: 1px solid #ccc; background: transparent; color: #777;
    font-size: 12px; letter-spacing: 1.5px; text-transform: uppercase;
    cursor: pointer; border-radius: 2px; transition: all 0.25s; font-family: inherit;
  }
  .studio-filter-btn:hover, .studio-filter-btn.active {
    border-color: #111; background: #111; color: #fff;
  }
  .studio-gallery-grid { columns: 3; column-gap: 10px; }
  @media (max-width: 992px) { .studio-gallery-grid { columns: 3; } }
  @media (max-width: 768px) { .studio-gallery-grid { columns: 2; } }
  @media (max-width: 480px) { .studio-gallery-grid { columns: 1; } }
  .studio-gallery-item {
    break-inside: avoid; margin-bottom: 10px; position: relative;
    overflow: hidden; border-radius: 4px; cursor: pointer; background: #eee;
  }
  .studio-gallery-item img { width: 100%; display: block; transition: transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94); }
  .studio-gallery-item:hover img { transform: scale(1.07); }
  .studio-gallery-item-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 55%);
    opacity: 0; transition: opacity 0.3s; display: flex; flex-direction: column;
    justify-content: flex-end; padding: 18px;
  }
  .studio-gallery-item:hover .studio-gallery-item-overlay { opacity: 1; }
  .studio-gallery-item-cat { font-size: 10px; letter-spacing: 2px; text-transform: uppercase; color: #ccc; margin-bottom: 4px; }
  .studio-gallery-item-name { font-size: 14px; font-weight: 600; color: #fff; }
  .studio-gallery-zoom {
    position: absolute; top: 12px; right: 12px; width: 34px; height: 34px;
    background: rgba(255,255,255,0.9); border: none; border-radius: 50%;
    font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center;
    opacity: 0; transform: scale(0.7); transition: all 0.25s; color: #111;
  }
  .studio-gallery-item:hover .studio-gallery-zoom { opacity: 1; transform: scale(1); }

  /* Lightbox */
  .studio-lightbox-overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,0.96); z-index: 9999;
    display: flex; align-items: center; justify-content: center;
    animation: studioFadeIn 0.2s ease;
  }
  @keyframes studioFadeIn { from { opacity:0; } to { opacity:1; } }
  .studio-lightbox-img {
    max-width: 88vw; max-height: 88vh; object-fit: contain;
    border-radius: 4px; box-shadow: 0 40px 100px rgba(0,0,0,0.7);
  }
  .studio-lightbox-close, .studio-lightbox-nav {
    position: fixed; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.25);
    color: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center;
    transition: all 0.2s; border-radius: 3px; z-index: 10000;
  }
  .studio-lightbox-close:hover, .studio-lightbox-nav:hover { background: rgba(255,255,255,0.2); }
  .studio-lightbox-close { top: 20px; right: 24px; width: 42px; height: 42px; font-size: 20px; }
  .studio-lightbox-nav { top: 50%; transform: translateY(-50%); width: 46px; height: 46px; font-size: 24px; }
  .studio-lightbox-prev { left: 16px; }
  .studio-lightbox-next { right: 16px; }
  .studio-lightbox-counter {
    position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%);
    color: #aaa; font-size: 13px; letter-spacing: 2px; z-index: 10000;
  }

  /* Process */
  .studio-process-section { padding: 90px 0; background: #111; color: #fff; }
  .studio-process-section .studio-section-title { color: #fff; }
  .studio-process-section .studio-section-sub { color: #888; }
  .studio-process-steps {
    display: grid; grid-template-columns: repeat(5,1fr); gap: 0; margin-top: 60px; position: relative;
  }
  @media (max-width: 992px) { .studio-process-steps { grid-template-columns: repeat(3,1fr); gap: 30px; } }
  @media (max-width: 576px) { .studio-process-steps { grid-template-columns: 1fr 1fr; gap: 24px; } }
  .studio-process-step { text-align: center; padding: 0 16px; position: relative; }
  .studio-process-step::after {
    content: '→'; position: absolute; right: -12px; top: 22px; font-size: 20px; color: #444;
  }
  .studio-process-step:last-child::after { display: none; }
  @media (max-width: 992px) { .studio-process-step::after { display: none; } }
  .studio-process-num {
    width: 52px; height: 52px; border-radius: 50%; border: 2px solid #333;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px; font-weight: 700; color: #fff; margin: 0 auto 16px; transition: all 0.3s;
  }
  .studio-process-step:hover .studio-process-num { border-color: #fff; background: #fff; color: #111; }
  .studio-process-step-title { font-size: 15px; font-weight: 600; color: #fff; margin-bottom: 8px; }
  .studio-process-step-desc { font-size: 13px; color: #666; line-height: 1.6; }

  /* Details */
  .studio-details-section { padding: 90px 0; background: #fafafa; }
  .studio-details-img {
    width: 100%; border-radius: 6px; object-fit: cover;
    height: 400px; box-shadow: 0 16px 48px rgba(0,0,0,0.08);
  }
  .studio-checklist { list-style: none; padding: 0; margin: 24px 0 32px; }
  .studio-checklist li {
    display: flex; align-items: flex-start; gap: 12px;
    margin-bottom: 12px; font-size: 15px; color: #444; line-height: 1.5;
  }
  .studio-checklist li img { width: 20px; height: 20px; margin-top: 2px; flex-shrink: 0; }

  /* Video */
  .studio-video-section { padding: 90px 0; background: #fff; }
  .studio-video-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 48px; }
  @media (max-width: 768px) { .studio-video-grid { grid-template-columns: 1fr; } }
  .studio-video-card { position: relative; border-radius: 5px; overflow: hidden; cursor: pointer; background: #111; }
  .studio-video-card-featured { grid-column: 1 / -1; }
  .studio-video-thumb {
    width: 100%; aspect-ratio: 16/9; object-fit: cover; display: block;
    transition: transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94);
  }
  .studio-video-card:hover .studio-video-thumb { transform: scale(1.04); }
  .studio-video-card-overlay {
    position: absolute; inset: 0; background: rgba(0,0,0,0.35);
    display: flex; align-items: center; justify-content: center; transition: background 0.3s;
  }
  .studio-video-card:hover .studio-video-card-overlay { background: rgba(0,0,0,0.22); }
  .studio-play-btn {
    width: 64px; height: 64px; border-radius: 50%; background: rgba(255,255,255,0.95);
    border: none; display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: all 0.3s; box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  }
  .studio-video-card-featured .studio-play-btn { width: 80px; height: 80px; }
  .studio-video-card:hover .studio-play-btn { transform: scale(1.1); background: #fff; }
  .studio-play-btn svg { width: 24px; height: 24px; fill: #111; margin-left: 4px; }
  .studio-video-card-featured .studio-play-btn svg { width: 30px; height: 30px; }
  .studio-video-info {
    position: absolute; bottom: 0; left: 0; right: 0; padding: 18px 22px;
    background: linear-gradient(to top, rgba(0,0,0,0.82), transparent);
  }
  .studio-video-tag { font-size: 10px; letter-spacing: 2px; text-transform: uppercase; color: #ccc; display: block; margin-bottom: 4px; }
  .studio-video-title { font-size: 15px; font-weight: 600; color: #fff; margin: 0; }
  .studio-video-card-featured .studio-video-title { font-size: 20px; }
  .studio-video-modal {
    position: fixed; inset: 0; background: rgba(0,0,0,0.97); z-index: 9999;
    display: flex; align-items: center; justify-content: center; animation: studioFadeIn 0.2s ease;
  }
  .studio-video-modal-inner { position: relative; width: min(920px, 94vw); }
  .studio-video-modal-inner iframe { width: 100%; aspect-ratio: 16/9; border: none; border-radius: 4px; display: block; }
  .studio-video-modal-close {
    position: absolute; top: -50px; right: 0; background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.25); color: #fff; width: 40px; height: 40px;
    border-radius: 3px; font-size: 18px; cursor: pointer;
    display: flex; align-items: center; justify-content: center; transition: all 0.2s;
  }
  .studio-video-modal-close:hover { background: rgba(255,255,255,0.2); }

  /* ── Inquiry Form Section ── */
  .studio-inquiry-section { padding: 90px 0; background: #f8f8f8; }

  .studio-inquiry-info-cards {
    display: flex; flex-direction: column; gap: 16px; height: 100%;
  }
  .studio-info-card {
    display: flex; align-items: flex-start; gap: 16px;
    background: #fff; border: 1px solid #efefef; border-radius: 6px;
    padding: 22px 24px; transition: box-shadow 0.25s, transform 0.25s;
  }
  .studio-info-card:hover { box-shadow: 0 8px 28px rgba(0,0,0,0.08); transform: translateY(-2px); }
  .studio-info-card-icon {
    width: 44px; height: 44px; border-radius: 50%; background: #f4f4f4;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .studio-info-card-icon img { width: 22px; height: 22px; }
  .studio-info-card-title { font-size: 13px; font-weight: 700; color: #111; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 4px; }
  .studio-info-card-value { font-size: 14px; color: #666; line-height: 1.5; margin: 0; }

  .studio-form-card {
    background: #fff; border-radius: 8px; padding: 44px 40px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.07); border: 1px solid #efefef;
  }
  @media (max-width: 576px) { .studio-form-card { padding: 28px 20px; } }
  .studio-form-title { font-size: 26px; font-weight: 700; color: #111; margin-bottom: 6px; }
  .studio-form-subtitle { font-size: 14px; color: #888; margin-bottom: 32px; }

  .studio-form-group { margin-bottom: 20px; }
  .studio-form-group label {
    display: block; font-size: 12px; font-weight: 600; letter-spacing: 1px;
    text-transform: uppercase; color: #555; margin-bottom: 8px;
  }
  .studio-form-group .form-control {
    width: 100%; padding: 12px 16px; border: 1px solid #e0e0e0;
    border-radius: 4px; font-size: 14px; color: #333; background: #fafafa;
    transition: border-color 0.2s, background 0.2s; outline: none;
    font-family: inherit;
  }
  .studio-form-group .form-control:focus { border-color: #111; background: #fff; }
  .studio-form-group textarea.form-control { resize: vertical; min-height: 120px; }
  .studio-form-group select.form-control { appearance: none; cursor: pointer; }

  .studio-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  @media (max-width: 576px) { .studio-form-row { grid-template-columns: 1fr; } }

  .studio-form-checkboxes { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 4px; }
  .studio-form-checkbox-label {
    display: flex; align-items: center; gap: 8px; cursor: pointer;
    font-size: 13px; color: #555; padding: 7px 14px;
    border: 1px solid #e0e0e0; border-radius: 20px; background: #fafafa;
    transition: all 0.2s; user-select: none;
  }
  .studio-form-checkbox-label input { display: none; }
  .studio-form-checkbox-label.checked { border-color: #111; background: #111; color: #fff; }

  .studio-form-success {
    display: none; background: #f0faf0; border: 1px solid #b6e5b6;
    border-radius: 4px; padding: 14px 18px; color: #2e7d32;
    font-size: 14px; font-weight: 500; margin-bottom: 20px;
  }
  .errorMessage { color: #e53e3e; font-size: 12px; margin-top: 4px; display: block; }

  /* Booking strip */
  .studio-booking-strip { background: #111; padding: 60px 0; text-align: center; }
  .studio-booking-strip h2 { font-size: clamp(22px,3vw,36px); color: #fff; font-weight: 700; margin-bottom: 12px; }
  .studio-booking-strip p { color: #888; font-size: 15px; margin-bottom: 28px; }
  .studio-booking-strip .btn { margin: 0 8px 10px; }
`;

// ── Static data ───────────────────────────────────────────────────────────────

const studioFeatures = [
  { icon: iconCamera,  title: 'Professional Equipment', desc: 'Top-of-the-line cameras, lenses, lighting rigs and grip equipment for flawless results every time.' },
  { icon: iconContent, title: 'Creative Direction',     desc: 'Our in-house creative team crafts mood boards, shot lists and visual narratives tailored to your brand.' },
  { icon: iconProcess, title: 'Post-Production',        desc: 'Colour grading, retouching, sound design and final delivery in any format — print, digital or broadcast.' },
  { icon: iconMeeting, title: 'Dedicated Support',      desc: 'A dedicated producer guides you from brief to delivery, keeping communication clear and timelines tight.' },
];

const studioGalleryData = [
  { id:1,  src:g1,  cat:'', name:'Portrait Series I'  },
  { id:2,  src:g2,  cat:'',     name:'Editorial Look'     },
  { id:3,  src:g3,  cat:'', name:'Studio Lighting'    },
  { id:4,  src:g4,  cat:'',     name:'Wardrobe Feature'   },
  { id:5,  src:g5,  cat:'', name:'Natural Mood'       },
  { id:6,  src:g6,  cat:'',     name:'Product Close-Up'   },
  { id:7,  src:g7,  cat:'',     name:'Campaign Shoot'     },
  { id:8,  src:g8,  cat:'', name:'Portrait Series II' },
  { id:9,  src:g9,  cat:'',     name:'Hero Shot'          },
  { id:10, src:g10, cat:'',     name:'Product Detail'     },
  { id:11, src:g11, cat:'',     name:'Lifestyle Look'     },
  { id:12, src:g12, cat:'',     name:'Brand Imagery'      },
];

//const GALLERY_FILTERS = ['all', 'photography', 'fashion', 'product'];
const GALLERY_FILTERS = ['all'];

const studioVideos = [
  { id:1, featured:true,  thumbnail:'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1400&q=80', tag:'Studio Tour',        title:'Inside Our Studio — Full Walkthrough', youtubeId:'dQw4w9WgXcQ' },
  { id:2, featured:false, thumbnail:'https://images.unsplash.com/photo-1536240478700-b869ad10e2d8?w=800&q=80',  tag:'Behind The Scenes',  title:'Fashion Shoot BTS',                    youtubeId:'dQw4w9WgXcQ' },
  { id:3, featured:false, thumbnail:'https://images.unsplash.com/photo-1574267432553-4b4628081c31?w=800&q=80',  tag:'Process',            title:'Lighting Setup Explained',             youtubeId:'dQw4w9WgXcQ' },
];

const processSteps = [
  { num:'01', title:'Brief & Discovery',    desc:'We understand your goals, brand tone and project scope.'  },
  { num:'02', title:'Concept & Mood Board', desc:'Visual direction, references and shot-list are approved.' },
  { num:'03', title:'Studio Shoot',         desc:'Full-day or half-day session with our complete crew.'     },
  { num:'04', title:'Post-Production',      desc:'Editing, grading, retouching and final colour pass.'      },
  { num:'05', title:'Delivery',             desc:'Files handed over in all required formats, on time.'      },
];

const SHOOT_TYPES = ['Photography', 'Video Production', 'Product Shoot', 'Fashion / Editorial', 'Corporate Film', 'Event Coverage', 'Other'];

const infoCards = [
  { icon: iconMap,  title: 'Studio Location', value: '84, 8th Floor World Business House,\nNear Parimal Garden, Ahmedabad' },
  { icon: iconCall, title: 'Call / WhatsApp',  value: '+91 9601801619' },
  { icon: iconMail, title: 'Email Us',         value: 'lensandlifestyle@gmail.com' },
  { icon: iconCal,  title: 'Studio Hours',     value: 'Mon – Sat: 8:00 AM – 6:00 PM\nSunday: By Appointment' },
];

// ── Sub-components ────────────────────────────────────────────────────────────

const StudioGallery = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxIdx, setLightboxIdx]   = useState(null);

  const filtered = activeFilter === 'all' ? studioGalleryData : studioGalleryData.filter(i => i.cat === activeFilter);
  const open  = idx => setLightboxIdx(idx);
  const close = ()  => setLightboxIdx(null);
  const next  = useCallback(() => setLightboxIdx(i => (i + 1) % filtered.length), [filtered.length]);
  const prev  = useCallback(() => setLightboxIdx(i => (i - 1 + filtered.length) % filtered.length), [filtered.length]);

  useEffect(() => {
    if (lightboxIdx === null) return;
    const fn = e => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft')  prev();
    };
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, [lightboxIdx, next, prev]);

  return (
    <>
      <div className="studio-filter-tabs" style={{display: "none"}}>
        {GALLERY_FILTERS.map(f => (
          <button key={f} className={`studio-filter-btn${activeFilter === f ? ' active' : ''}`} onClick={() => setActiveFilter(f)}>{f}</button>
        ))}
      </div>
      <div className="studio-gallery-grid">
        {filtered.map((img, idx) => (
          <div className="studio-gallery-item" key={img.id} onClick={() => open(idx)}>
            <img src={img.src} alt={img.name} loading="lazy" />
            <div className="studio-gallery-item-overlay">
              <span className="studio-gallery-item-cat">{img.cat}</span>
              <span className="studio-gallery-item-name">{img.name}</span>
            </div>
            <button className="studio-gallery-zoom" aria-label="Zoom">+</button>
          </div>
        ))}
      </div>
      {lightboxIdx !== null && (
        <div className="studio-lightbox-overlay" onClick={close}>
          <img className="studio-lightbox-img" src={filtered[lightboxIdx].src} alt={filtered[lightboxIdx].name} onClick={e => e.stopPropagation()} />
          <button className="studio-lightbox-close" onClick={close}>✕</button>
          <button className="studio-lightbox-nav studio-lightbox-prev" onClick={e => { e.stopPropagation(); prev(); }}>‹</button>
          <button className="studio-lightbox-nav studio-lightbox-next" onClick={e => { e.stopPropagation(); next(); }}>›</button>
          <span className="studio-lightbox-counter">{lightboxIdx + 1} / {filtered.length}</span>
        </div>
      )}
    </>
  );
};

const StudioVideos = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  useEffect(() => {
    if (!activeVideo) return;
    const fn = e => { if (e.key === 'Escape') setActiveVideo(null); };
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, [activeVideo]);

  return (
    <>
      <div className="studio-video-grid">
        {studioVideos.map(v => (
          <div key={v.id} className={`studio-video-card${v.featured ? ' studio-video-card-featured' : ''}`} onClick={() => setActiveVideo(v)}>
            <img className="studio-video-thumb" src={v.thumbnail} alt={v.title} loading="lazy" />
            <div className="studio-video-card-overlay">
              <button className="studio-play-btn" aria-label="Play">
                <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
              </button>
            </div>
            <div className="studio-video-info">
              <span className="studio-video-tag">{v.tag}</span>
              <p className="studio-video-title">{v.title}</p>
            </div>
          </div>
        ))}
      </div>
      {activeVideo && (
        <div className="studio-video-modal" onClick={() => setActiveVideo(null)}>
          <div className="studio-video-modal-inner" onClick={e => e.stopPropagation()}>
            <button className="studio-video-modal-close" onClick={() => setActiveVideo(null)}>✕</button>
            <iframe src={`https://www.youtube.com/embed/${activeVideo.youtubeId}?autoplay=1`} title={activeVideo.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        </div>
      )}
    </>
  );
};

// ── Studio Inquiry Form ───────────────────────────────────────────────────────

const StudioInquiryForm = () => {
  const [forms, setForms] = useState({
    name: '', email: '', phone: '', company: '',
    shootDate: '', duration: '', budget: '', message: '',
  });
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [validator]  = useState(new SimpleReactValidator({ className: 'errorMessage' }));
  const [, forceUpdate] = useState(0);

  const changeHandler = e => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    if (validator.allValid()) { validator.hideMessages(); } else { validator.showMessages(); }
    forceUpdate(n => n + 1);
  };

  const toggleType = type => {
    setSelectedTypes(prev =>
      prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]
    );
  };

  const submitHandler = e => {
    e.preventDefault();
    if (validator.allValid()) {
      const payload = { ...forms, shootTypes: selectedTypes.join(', ') };
      axios
        .post('./api/studio-inquiry.php', payload)
        .then((res) => {
          if (res.data.status === 'success') {
            document.querySelector('.studio-form-success').style.display = 'block';
            document.querySelector('.studio-form-error').style.display   = 'none';
            setForms({ name:'', email:'', phone:'', company:'', shootDate:'', duration:'', budget:'', message:'' });
            setSelectedTypes([]);
            validator.hideMessages();
            forceUpdate(n => n + 1);
          } else {
            document.querySelector('.studio-form-error').style.display = 'block';
          }
        })
        .catch(err => {
          console.error('Studio inquiry error:', err);
          document.querySelector('.studio-form-error').style.display = 'block';
        });
    } else {
      validator.showMessages();
      forceUpdate(n => n + 1);
    }
  };

  return (
    <section className="studio-inquiry-section">
      <div className="container">
        <div className="row g-5">

          {/* ── Left: info cards ── */}
          <div className="col-lg-4">
            <p className="studio-section-eyebrow">Get In Touch</p>
            <h2 className="studio-section-title" style={{ marginBottom: 12 }}>Studio<br />Enquiry</h2>
            <p className="studio-section-sub">
              Fill in the form and our team will get back to you within 24 hours to confirm availability and discuss your shoot.
            </p>
            <div className="studio-inquiry-info-cards">
              {infoCards.map((card, i) => (
                <div className="studio-info-card" key={i}>
                  <div className="studio-info-card-icon">
                    <img src={card.icon} alt={card.title} />
                  </div>
                  <div>
                    <p className="studio-info-card-title">{card.title}</p>
                    <p className="studio-info-card-value">{card.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Right: form ── */}
          <div className="col-lg-8">
            <div className="studio-form-card">
              <h3 className="studio-form-title">Book a Studio Session</h3>
              <p className="studio-form-subtitle">Tell us about your project and preferred dates — we'll make it happen.</p>

              <div className="studio-form-success">
                🎉 Thank you! Your inquiry has been received. We'll be in touch within 24 hours.
              </div>
			  
			  <iframe
				  id="myiframe"
				  src="https://lensandlifestyle.in/studioformnew/contact.php"
				  style={{
					border: "none",
					width: "100%",
					height: 1050,
					marginBottom: 15
				  }}
				  title="Iframe Example"
			  />
              
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

// ── Page ──────────────────────────────────────────────────────────────────────

const ClickHandler = () => { window.scrollTo(10, 0); };

const StudioPage = () => {
  return (
    <Fragment>
      <style>{studioStyles}</style>
      <Header />

      <main className="page_content">
        <PageTitle pageTitle="Our Studio" pagesub="Explore 🎬" pageTop="Welcome to" />

        {/* 1. Intro */}
        <section className="studio-intro-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <img src={heroImg} alt="Lens & Lifestyle Studio" className="studio-hero-img" />
              </div>
              <div className="col-lg-6">
                <span className="studio-badge bg-secondary text-white">Lens &amp; Lifestyle Studio</span>
                <h2 className="studio-heading">Where <mark>Vision</mark> Meets<br />the Camera</h2>
                <p className="studio-lead">
                  Our fully equipped Mumbai studio is designed for photographers, brands and creative teams who demand exceptional quality. From intimate portrait sessions to large-scale commercial productions — every shoot begins and ends with craft.
                </p>
                <p className="studio-lead">
                  With professional cyclorama walls, modular lighting rigs, a dedicated wardrobe suite and an experienced on-site crew, we provide everything you need to bring your creative vision to life without compromise.
                </p>
                <div className="studio-stats-bar" style={{display: "none"}}>
                  <div className="studio-stat-item"><div className="studio-stat-num">3000+</div><div className="studio-stat-lbl">Shoot Days</div></div>
                  <div className="studio-stat-item"><div className="studio-stat-num">500+</div><div className="studio-stat-lbl">Clients</div></div>
                  <div className="studio-stat-item"><div className="studio-stat-num">8+</div><div className="studio-stat-lbl">Years Active</div></div>
                  <div className="studio-stat-item"><div className="studio-stat-num">4K</div><div className="studio-stat-lbl">sq. ft.</div></div>
                </div>
                <Link to="/contact" onClick={ClickHandler} className="btn btn-primary me-3" style={{display: "none"}}>
                  <span className="btn_label" data-text="Book the Studio">Book the Studio</span>
                  <span className="btn_icon"><i className="fa-solid fa-arrow-up-right"></i></span>
                </Link>
                <Link to="/portfolio" onClick={ClickHandler} className="btn btn-outline-dark" style={{display: "none"}}>
                  <span className="btn_label" data-text="View Portfolio">View Portfolio</span>
                  <span className="btn_icon"><i className="fa-solid fa-arrow-up-right"></i></span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* 2. Features */}
        <section className="studio-features-section">
          <div className="container">
            <div className="text-center">
              <p className="studio-section-eyebrow">What We Offer</p>
              <h2 className="studio-section-title">Everything Under One Roof</h2>
              <p className="studio-section-sub">A complete production environment — no external hiring, no logistic headaches.</p>
            </div>
            <div className="studio-features-grid">
              {studioFeatures.map((f, i) => (
                <div className="studio-feature-card" key={i}>
                  <img src={f.icon} alt={f.title} className="studio-feature-icon" />
                  <h4 className="studio-feature-title">{f.title}</h4>
                  <p className="studio-feature-desc">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 3. Gallery */}
        <section className="studio-gallery-section">
          <div className="container">
            <h2 className="text-center studio-section-title">Our Studio</h2>
            <p className="text-center studio-section-sub">A curated selection of photography, fashion and product shoots produced in our studio.</p>
            <StudioGallery />
          </div>
        </section>

        {/* 4. Process */}
        <section className="studio-process-section" style={{display: "none"}}>
          <div className="container">
            <div className="text-center">
              <p className="studio-section-eyebrow" style={{ color:'#555' }}>How It Works</p>
              <h2 className="studio-section-title">Our Shoot Process</h2>
              <p className="studio-section-sub">A clear, collaborative workflow from brief to final delivery.</p>
            </div>
            <div className="studio-process-steps">
              {processSteps.map(s => (
                <div className="studio-process-step" key={s.num}>
                  <div className="studio-process-num">{s.num}</div>
                  <h5 className="studio-process-step-title">{s.title}</h5>
                  <p className="studio-process-step-desc">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. Details */}
        <section className="studio-details-section" style={{display: "none"}}>
          <div className="container">
            <div className="row align-items-center g-5 mb-80">
              <div className="col-lg-6">
                <img src={detailImg1} alt="Studio Equipment" className="studio-details-img" />
              </div>
              <div className="col-lg-6">
                <p className="studio-section-eyebrow">The Space</p>
                <h2 className="studio-section-title">Built for<br />Creative Excellence</h2>
                <p style={{ color:'#666', lineHeight:1.8, marginBottom:8 }}>
                  Our 4,000 sq. ft. main studio floor features a seamless cyclorama, black-out capability, dedicated makeup and wardrobe rooms, a client lounge and a production prep zone.
                </p>
                <ul className="studio-checklist">
                  {['Infinity cove (cyclorama) — white & black','Phase One, Sony & Nikon camera systems','Profoto & Broncolor strobe systems','Dedicated makeup, hair & wardrobe suite','Secure, climate-controlled storage','High-speed tethered shooting setup'].map((item, i) => (
                    <li key={i}><img src={iconCheck} alt="✓" />{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="row align-items-center g-5">
              <div className="col-lg-6 order-lg-2">
                <img src={detailImg2} alt="Post-Production Suite" className="studio-details-img" />
              </div>
              <div className="col-lg-6 order-lg-1">
                <p className="studio-section-eyebrow">Post-Production</p>
                <h2 className="studio-section-title">From Raw Files<br />to Final Art</h2>
                <p style={{ color:'#666', lineHeight:1.8, marginBottom:8 }}>
                  Our colour-calibrated editing suite handles everything in-house — so your images and videos are colour-graded, retouched and packaged to the highest standard before delivery.
                </p>
                <ul className="studio-checklist">
                  {['Colour-calibrated NEC & Eizo monitors','Capture One & Adobe Creative Suite','Expert skin retouching & compositing','DaVinci Resolve colour grading','Delivery in any format — TIFF, JPEG, RAW, MP4, ProRes','Rush turnaround available'].map((item, i) => (
                    <li key={i}><img src={iconCheck} alt="✓" />{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 7. Inquiry Form ← NEW */}
        <StudioInquiryForm />

        <CtaSection />
      </main>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default StudioPage;
